define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/table/New",
	"csi/xml"
], function(declare,locale,New,xml) {

	return declare(New, {
		/**
		 * Change the localization name of Node Name
		 * @param {csi.view.Widget} view
		 */
		onCreatePopup: function(view) {
			var nodeNameField = view.getField(xml.ATTR_NAME);
			nodeNameField.m_label = locale.resource("SpecificationSection");
			this.inherited(arguments);
		},

		postProcessSuccess: function() {
			this.widget.refreshWidget();
		},

		/**
		 * hide the Save & Go button on the form
		 * @return {boolean}
		*/
		_canNavigate: function() {
			return false;
		}
	});
});